import type { FC, ReactNode } from "react";

import { Button, Column, Row, SparkleIcon } from "@hightouch/htui";
import { Card as AppCard } from "src/components/card/card";

import { useStartChatFromPrompt } from "./use-start-chat-from-prompt";

// <insight-card> — a bordered frame the agent fills with markdown plus the
// <actions>/chart tags. Blank lines around the tags are required for the
// markdown inside to render.
export const InsightCard: FC<Readonly<{ children?: ReactNode }>> = ({
  children,
}) => (
  <AppCard my={4} p={4} gap={3}>
    {children}
  </AppCard>
);

// Frameless variant for hosts that already supply their own frame, passed as a
// `components` override to DangerousMarkdownWithHtml.
export const InsightCardFrameless: FC<Readonly<{ children?: ReactNode }>> = ({
  children,
}) => <Column gap={3}>{children}</Column>;

export const Actions: FC<Readonly<{ children?: ReactNode }>> = ({
  children,
}) => (
  <Row gap={2} flexWrap="wrap">
    {children}
  </Row>
);

// <action prompt="...">Label</action> — a button that opens a brand-new agent
// chat seeded with `prompt` (submits immediately). `insightId` references the
// `initiative_insights` row when the card is backed by a persisted insight.
export const Action: FC<
  Readonly<{ prompt?: string; insightId?: string; children?: ReactNode }>
> = ({ prompt, insightId, children }) => {
  const startChat = useStartChatFromPrompt();
  if (!prompt) {
    return null;
  }
  return (
    <Button
      size="sm"
      icon={SparkleIcon}
      onClick={() => startChat(prompt, insightId ? { insightId } : undefined)}
    >
      {children}
    </Button>
  );
};
